module.exports = __webpack_public_path__ + "img/drexellogo.f7279594.jpg";